module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lwdh-box"
  }, _vm._l((_vm.inLwList), function(item, index) {
    return _c('div', {
      key: ("lw-" + index),
      staticClass: "inRoomLiwu-box lwdh-slide-in",
      style: ({
        zIndex: 10 - index
      })
    }, [_c('div', {
      staticClass: "inRoomLiwu-box-left"
    }, [_c('img', {
      attrs: {
        "src": item.details.sendUserInfo.headPortrait
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "inRoomLiwu-box-left-content"
    }, [_c('span', {
      staticClass: "inRoomLiwu-box-left-content-span"
    }, [_vm._v(_vm._s(item.details.sendUserInfo.nickName) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "inRoomLiwu-box-left-content-div"
    }, [_c('span', {
      staticClass: "inRoomLiwu-box-left-content-div-span"
    }, [_vm._v(_vm._s(_vm.$t('all.songgei')))]), _vm._v(" "), _c('span', {
      staticClass: "inRoomLiwu-box-left-content-div-span1"
    }, [_vm._v(_vm._s(item.details.toUserInfo.nickName))])])])]), _vm._v(" "), _c('div', {
      staticClass: "inRoomLiwu-box-right"
    }, [_c('img', {
      staticClass: "inRoomLiwu-box-right-img",
      attrs: {
        "src": item.details.giftInfo.imgUrl
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "inRoomLiwu-box-right-num"
    }, [_c('span', {
      staticClass: "inRoomLiwu-box-right-num-span"
    }, [_vm._v("×")]), _vm._v(" "), _c('span', {
      staticClass: "inRoomLiwu-box-right-num-span1"
    }, [_vm._v(_vm._s(item.details.num))])])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-766935ad"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/liwudonghua/liwudonghua.vue
// module id = 992
// module chunks = 1